import { AlertModule } from '@/store/alert';
import { AuthModule } from '@/store/auth';
import { AuthenticationModule } from '@/store/authentication';
import { CardModule } from '@/store/card';
import { ConfigModule } from '@/store/config';
import { DomainDetailModule } from '@/store/domain-detail';
import { DownloaderModule } from '@/store/downloader';
import { GuestModule } from '@/store/guest';
import { LoadingModule } from '@/store/loading';
import { MaintenanceModule } from '@/store/maintenance';
import { MessageModule } from '@/store/message';
import { NavModule } from '@/store/nav';
import { NotificationModule } from '@/store/notification';
import { SmsModule } from '@/store/sms';
import { UserModule } from '@/store/user';
import { WebsiteModule } from '@/store/website';
import { WPHostingModule } from '@/store/wp-hosting';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        config: ConfigModule,
        auth: AuthModule,
        authentication: AuthenticationModule,
        nav: NavModule,
        message: MessageModule,
        alert: AlertModule,
        loading: LoadingModule,
        domainDetail: DomainDetailModule,
        notification: NotificationModule,
        user: UserModule,
        sms: SmsModule,
        guest: GuestModule,
        maintenance: MaintenanceModule,
        website: WebsiteModule,
        wpHosting: WPHostingModule,
        downloader: DownloaderModule,
        card: CardModule,
    },
});
